import { isEmpty } from "src/core/utils/common";
import * as yup from "yup";

export const bracketDetailsValidationSchema = yup.object().shape({
  bracketDetails: yup
    .object()
    .nullable()
    .shape({
      tiltAngle: yup.number().fromFormik().required().min(0).max(45),
      bracketLength: yup
        .number()
        .fromFormik()
        .when("bracketHeight", {
          is: (bracketHeight: number | null | undefined) =>
            isEmpty(bracketHeight),
          then: (schema) => schema.required(),
          otherwise: (schema) => schema.optional(),
        }),
      bracketHeight: yup.number().fromFormik().min(0),
      bracketQualifiedForReplacement: yup.boolean().nullable(),
      newBracketLengthAfterReplacement: yup.number().fromFormik().min(0),
      newBracketHeightAfterReplacement: yup.number().fromFormik().min(0),
      dateOfBracketPainting: yup
        .date()
        .fromFormik()
        .nullable()
        .default(undefined)
        .max(new Date()),
    }),
});
